// client/src/components/HeroV3.js
import React, { useState, useEffect, useMemo } from 'react';
import CountUp from 'react-countup';
import './HeroV3.css';

// Background images
const slideImages = [
  '/images/hero-slide-1.jpeg', // Ensure you are using the correct file extension (.jpg, .jpeg, etc.)
  '/images/hero-slide-2.jpeg',
  '/images/hero-slide-3.jpeg'
];

const HeroV3 = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState(0);

  // Memoize testimonials to ensure stability for the useEffect hook
  const testimonials = useMemo(() => [
    {
      quote: "The reliability of Makah Medics' dialysis machines has been a game-changer... their proactive maintenance and rapid support truly sets them apart.",
      author: "Dr. Aisha Omar",
      title: "Renal Unit Head, Mwanza City Hospital"
    },
    {
      quote: "Makah Medics provides consistent, high-quality supplies on a reliable schedule. Their professionalism has significantly improved our operational efficiency.",
      author: "Mr. David Cheni",
      title: "Head of Procurement, Heameda Hospital"
    },
    {
      quote: "The technical team at Makah Medics is exceptional. Their training was thorough and practical, giving us immense confidence in the equipment.",
      author: "Fatima Juma",
      title: "Lead Biomedical Engineer, Muhimbili National Hospital"
    }
  ], []);

  // Effect for changing the background image
  useEffect(() => {
    const imageInterval = setInterval(() => {
      setCurrentImageIndex(prevIndex => (prevIndex + 1) % slideImages.length);
    }, 8000); // Change image every 8 seconds
    return () => clearInterval(imageInterval);
  }, []);

  // Effect for changing the testimonial
  useEffect(() => {
    const testimonialInterval = setInterval(() => {
      setCurrentTestimonialIndex(prevIndex => (prevIndex + 1) % testimonials.length);
    }, 7000); // Testimonials slide every 7 seconds
    return () => clearInterval(testimonialInterval);
  }, [testimonials]);
  
  const currentTestimonial = testimonials[currentTestimonialIndex];

  return (
    <div className="hero-container-v3">
      {/* Background Image Slideshow */}
      <div className="hero-images-v3">
        {slideImages.map((src, index) => (
          <div
            key={src}
            className={`hero-image-v3 ${index === currentImageIndex ? 'active' : ''}`}
            style={{ backgroundImage: `url(${src})` }}
          ></div>
        ))}
      </div>
      
      {/* Lighter, more subtle overlay */}
      <div className="hero-overlay-v3"></div>
      
      {/* Main Content Area */}
      <div className="hero-content-v3">
        {/* Title and Motto remain at the top */}
        <div className="hero-text-content">
          <h1 className="hero-title">Makah Medics</h1>
          <p className="hero-motto">For a Healthy Society</p>
        </div>

        {/* NEW: Sliding Testimonial Section in the middle */}
        <div className="testimonial-slider-v3" key={currentTestimonialIndex}>
          <p className="testimonial-quote-v3">"{currentTestimonial.quote}"</p>
          <div className="testimonial-author-v3">
            <strong>{currentTestimonial.author}</strong>
            <span>{currentTestimonial.title}</span>
          </div>
        </div>
      </div>

      {/* Stats Bar remains at the bottom */}
      <div className="hero-stats-bar">
        <div className="stat-item">
          <CountUp end={100} duration={3} suffix="%"/>
          <p>Customer Satisfaction</p>
        </div>
        <div className="stat-item">
          <CountUp end={50} duration={3} prefix="+"/>
          <p>Successful Installations</p>
        </div>
        <div className="stat-item">
          <CountUp end={24} duration={3} suffix="/7"/>
          <p>Support & Maintenance</p>
        </div>
        <div className="stat-item">
          <CountUp end={15} duration={3} prefix="+"/>
          <p>Regions Served in Tanzania</p>
        </div>
      </div>
    </div>
  );
};

export default HeroV3;